var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-dialog',{attrs:{"title":"新增手术信息","width":"80%","visible":_vm.visibleSync,"data":{},"columns":_vm.columnList,"buttons":_vm.editButtons},on:{"update:visible":function($event){_vm.visibleSync=$event},"confirm":_vm.postOne}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f25fd7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scheduling/AddSurgery.vue
// module id = null
// module chunks = 